import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
// import Link from "gatsby-plugin-transition-link/Link"

import "./barras.scss"

export const BarraSoluciones = () => {
  return (
    <div className="barra-soluciones-container">
      <Link bg="#253eaf" to="/soluciones/salas-multimedia">
        <StaticImage
          src="../../images/barra-soluciones/SALAS MULTIMEDIA-BLANCO.svg"
          alt="logo soluciones salas multimedia"
          placeholder="tracedSVG"
        />
      </Link>
      <Link bg="#253eaf" to="/soluciones/videoconferencia">
        <StaticImage
          src="../../images/barra-soluciones/VIDEO-COMFERENCIA-BLANCO.svg"
          alt="logo soluciones video comferencia"
          placeholder="tracedSVG"
        />
      </Link>
      <Link bg="#253eaf" to="/soluciones/sonorizacion">
        <StaticImage
          src="../../images/barra-soluciones/SINCRO AMBIENTE-BLANCO.svg"
          alt="logo soluciones ambiente"
          placeholder="tracedSVG"
        />
      </Link>
      <Link bg="#253eaf" to="/soluciones/proyectores">
        <StaticImage
          src="../../images/barra-soluciones/PROYECTOR-BLANCO.svg"
          alt="logo solucionesproyector"
          placeholder="tracedSVG"
        />
      </Link>
      <Link bg="#253eaf" to="/soluciones/automatizacion">
        <StaticImage
          src="../../images/barra-soluciones/AUTOMATIZACION-BLANCO.svg"
          alt="logo soluciones automatizacion"
          placeholder="tracedSVG"
        />
      </Link>
      <Link bg="#253eaf" to="/soluciones/mobiliario">
        <StaticImage
          src="../../images/barra-soluciones/MOBILIARIO-BLANCO.svg"
          alt="logo soluciones mobiliario"
          placeholder="tracedSVG"
        />
      </Link>
      <Link bg="#253eaf" to="/soluciones/videowall">
        <StaticImage
          src="../../images/barra-soluciones/VIDEO-WALL-BLANCO.svg"
          alt="logo soluciones video wall"
          placeholder="tracedSVG"
        />
      </Link>
    </div>
  )
}
